export const iconFontAwesomeCodingDiagramProject = (
	<i className="fa-solid fa-diagram-project"></i>
);
